import { useCallback } from 'react';

import { fetchCasinoConfigAction } from '../apiActions/fetchCasinoConfigAction';
import { useCoreDispatch } from '../CoreStore';
import { useConfigSlice } from '../slices/config/selectors';

export const useCasinoConfigFetcher = (essential: boolean, language?: string): (() => void) => {
  const dispatch = useCoreDispatch();
  const JSESSIONID = useConfigSlice.JSESSIONID();
  const baseUrl = useConfigSlice.baseUrl();

  return useCallback((): void => {
    if (JSESSIONID && baseUrl) {
      dispatch(fetchCasinoConfigAction({ JSESSIONID, baseUrl, essential, language }));
    }
  }, [JSESSIONID, baseUrl, dispatch, essential, language]);
};
